export default {
  'name': '3D打印色盘',
  'hide': false,
  'data': [
    {
      'id': 'B100',
      'name': '白色',
      'hex': '#FFFFFF'
    },
    {
      'id': 'B104',
      'name': '浅灰',
      'hex': '#D1D3D5'
    },
    {
      'id': 'B103',
      'name': '灰色',
      'hex': '#8E9089'
    },
    {
      'id': 'B105',
      'name': '深灰',
      'hex': '#545454'
    },
    {
      'id': 'B101',
      'name': '黑色',
      'hex': '#000000'
    },
    {
      'id': 'B400',
      'name': '黄色',
      'hex': '#F4EE2A'
    },
    {
      'id': 'B402',
      'name': '暖黄色',
      'hex': '#FEC600'
    },
    {
      'id': 'B301',
      'name': '南瓜橙',
      'hex': '#FF9016'
    },
    {
      'id': 'B300',
      'name': '橙色',
      'hex': '#FF6A13'
    },
    {
      'id': 'B200',
      'name': '红色',
      'hex': '#C12E1F'
    },
    {
      'id': 'B605',
      'name': '松石绿',
      'hex': '#00B1B7'
    },
    {
      'id': 'B603',
      'name': '青色',
      'hex': '#0086D6'
    },
    {
      'id': 'B604',
      'name': '钴蓝色',
      'hex': '#0056B8'
    },
    {
      'id': 'B601',
      'name': '蓝色',
      'hex': '#0A2989'
    },
    {
      'id': 'B700',
      'name': '紫色',
      'hex': '#5E43B7'
    },
    {
      'id': 'B701',
      'name': '绀紫色',
      'hex': '#482960'
    },
    {
      'id': 'B203',
      'name': '粉色',
      'hex': '#F55A74'
    },
    {
      'id': 'B202',
      'name': '品红',
      'hex': '#EC008C'
    },
    {
      'id': 'B800',
      'name': '棕色',
      'hex': '#9D432C'
    },
    {
      'id': 'B205',
      'name': '胭脂红',
      'hex': '#9D2235'
    },
    {
      'id': 'B503',
      'name': '苹果绿',
      'hex': '#BECF00'
    },
    {
      'id': 'B501',
      'name': '绿色',
      'hex': '#00AE42'
    },
    {
      'id': 'B502',
      'name': '圣诞绿',
      'hex': '#3F8E43'
    },
    {
      'id': 'B500',
      'name': '墨绿色',
      'hex': '#164B35'
    }
    // {
    //   'id': 'B602',
    //   'name': '蓝灰',
    //   'hex': '#5B6579'
    // },
    // {
    //   'id': 'B201',
    //   'name': '杏色',
    //   'hex': '#F7E6DE'
    // },
    // {
    //   'id': 'B802',
    //   'name': '可可棕',
    //   'hex': '#6F5034'
    // },
    // {
    //   'id': 'B401',
    //   'name': '金色',
    //   'hex': '#E4BD68'
    // },
    // {
    //   'id': 'B102',
    //   'name': '银色',
    //   'hex': '#A6A9AA'
    // },
    // {
    //   'id': 'B801',
    //   'name': '青铜',
    //   'hex': '#847D48'
    // }
    // {
    //   'id': 'B204',
    //   'name': '桃红色',
    //   'hex': '#F5547C'
    // },
  ]
}
